import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { authActions } from "../store/auth-slice";
import { getAuthToken } from "../util/authToken";

/** Clears persisted "logged in" state when no Bearer token is available (e.g. new tab or stale session). */
const AuthSessionSync = () => {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector((s) => s.auth.isLoggedIn);

  useEffect(() => {
    if (isLoggedIn && !getAuthToken()) {
      dispatch(authActions.logout());
    }
  }, [isLoggedIn, dispatch]);

  return null;
};

export default AuthSessionSync;
